<template>
  <div class="">
    <div class="text-center font-bold text-2xl pt-3">
        3 phút duyệt nhanh, nhận tiền thật nhanh
    </div>
    <div class="mt-3 grid grid-cols-3 m-auto text-center">
        <div class="md:col-span-1 col-span-3 lg:pt-5">
            
            <div class="grid grid-cols-6 p-3 text-left">
                <div class="align-middle pt-3">
                    <img alt="khong_cm_thu_nhap" src="@/assets/default_main/ld_fm/profile.svg" />
                </div>
                <div class="col-span-5">
                    <div class="font-bold-vmain color-vmain2 text-lg">
                        Thủ tục đơn giản
                    </div>
                    <div>
                        Chỉ cần CMND/CCCD
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-6 p-3 text-left">
                <div class="align-middle pt-3">
                    <img alt="thu_tuc_don_gian" src="@/assets/default_main/ld_fm/loan.svg" />
                </div>
                <div class="col-span-5">
                    <div class="font-bold-vmain color-vmain2 text-lg">
                        Gói vay đa dạng
                    </div>
                    <div>
                        Cung cấp gói vay từ 2 triệu đến 20 triệu với kỳ hạn thanh toán lên đến 18 tháng và lãi suất cạnh tranh
                    </div>
                </div>
            </div>
        </div>
        <div class="lg:col-span-1 display-non-mobile md:hidden">
            <img src="@/assets/default_main/ld_fm/img_momo.jpg" />
        </div>
        <div class="md:col-span-1 col-span-3 lg:pt-5">
            <div class="grid grid-cols-6 p-3 text-left">
                <div class="align-middle pt-3">
                    <img alt="thu_tuc_don_gian" src="@/assets/default_main/ld_fm/calendar.svg" />
                </div>
                <div class="col-span-5">
                    <div class="font-bold-vmain color-vmain2 text-lg">
                        Trả góp từng kỳ
                    </div>
                    <div>
                        Bạn được phép thanh toán từng kỳ
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-6 p-3 text-left">
                <div class="align-middle pt-3">
                    <img alt="khong_cm_thu_nhap" src="@/assets/default_main/ld_fm/history.svg" />
                </div>
                <div class="col-span-5">
                    <div class="font-bold-vmain color-vmain2 text-lg">
                        Duyệt nhanh
                    </div>
                    <div>
                        Duyệt vay nhanh chỉ trong 1 phút
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>